"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protocol = exports.DeviceToCloud = exports.CloudToDeviceEnvelope = exports.CloudToDevice = exports.NAMESPACE = exports.V3 = exports.V2 = exports.Common = void 0;
const effect_1 = require("effect");
exports.Common = __importStar(require("./common"));
const V2 = __importStar(require("./v2"));
const V3 = __importStar(require("./v3"));
exports.V2 = __importStar(require("./v2"));
exports.V3 = __importStar(require("./v3"));
exports.NAMESPACE = 'Culligan.Protocol';
exports.CloudToDevice = effect_1.Schema.Union(V3.CloudToDevice, V2.CloudToDevice).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDevice`,
    title: 'Cloud to Device',
    description: 'Cloud to Device Message Protocol',
});
exports.CloudToDeviceEnvelope = effect_1.Schema.Union(V3.CloudToDevice, V2.CloudToDeviceEnvelope).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDeviceEnvelope`,
    title: 'Cloud to Device Envelope',
    description: 'Envelope-only Cloud to Device Message Protocol',
});
exports.DeviceToCloud = effect_1.Schema.Union(V3.DeviceToCloud, V2.DeviceToCloud).annotations({
    identifier: `${exports.NAMESPACE}.DeviceToCloud`,
    title: 'Device to Cloud',
    description: 'Device to Cloud Message Protocol',
});
exports.Protocol = effect_1.Schema.Union(V3.Protocol, V2.Protocol).annotations({
    identifier: `${exports.NAMESPACE}.Protocol`,
    title: 'Culligan Message Protocol',
    description: 'The Culligan device-to-cloud and cloud-to-device message protocols',
});
//# sourceMappingURL=index.js.map